/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiSanctionClearanceSandboxEntityType } from './ApiSanctionClearanceSandboxEntityType';
import {
    ApiSanctionClearanceSandboxEntityTypeFromJSON,
    ApiSanctionClearanceSandboxEntityTypeFromJSONTyped,
    ApiSanctionClearanceSandboxEntityTypeToJSON,
    ApiSanctionClearanceSandboxEntityTypeToJSONTyped,
} from './ApiSanctionClearanceSandboxEntityType';

/**
 * 
 * @export
 * @interface ApiScreeningClearanceRuleTestCase
 */
export interface ApiScreeningClearanceRuleTestCase {
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningClearanceRuleTestCase
     */
    entityExternalId?: string;
    /**
     * 
     * @type {ApiSanctionClearanceSandboxEntityType}
     * @memberof ApiScreeningClearanceRuleTestCase
     */
    entityType?: ApiSanctionClearanceSandboxEntityType;
    /**
     * 
     * @type {number}
     * @memberof ApiScreeningClearanceRuleTestCase
     */
    screeningAlertId?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningClearanceRuleTestCase
     */
    rule: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiScreeningClearanceRuleTestCase
     */
    useExistingHits?: boolean;
}



/**
 * Check if a given object implements the ApiScreeningClearanceRuleTestCase interface.
 */
export function instanceOfApiScreeningClearanceRuleTestCase(value: object): value is ApiScreeningClearanceRuleTestCase {
    if (!('rule' in value) || value['rule'] === undefined) return false;
    return true;
}

export function ApiScreeningClearanceRuleTestCaseFromJSON(json: any): ApiScreeningClearanceRuleTestCase {
    return ApiScreeningClearanceRuleTestCaseFromJSONTyped(json, false);
}

export function ApiScreeningClearanceRuleTestCaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScreeningClearanceRuleTestCase {
    if (json == null) {
        return json;
    }
    return {
        
        'entityExternalId': json['entityExternalId'] == null ? undefined : json['entityExternalId'],
        'entityType': json['entityType'] == null ? undefined : ApiSanctionClearanceSandboxEntityTypeFromJSON(json['entityType']),
        'screeningAlertId': json['screeningAlertId'] == null ? undefined : json['screeningAlertId'],
        'rule': json['rule'],
        'useExistingHits': json['useExistingHits'] == null ? undefined : json['useExistingHits'],
    };
}

export function ApiScreeningClearanceRuleTestCaseToJSON(json: any): ApiScreeningClearanceRuleTestCase {
    return ApiScreeningClearanceRuleTestCaseToJSONTyped(json, false);
}

export function ApiScreeningClearanceRuleTestCaseToJSONTyped(value?: ApiScreeningClearanceRuleTestCase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityExternalId': value['entityExternalId'],
        'entityType': ApiSanctionClearanceSandboxEntityTypeToJSON(value['entityType']),
        'screeningAlertId': value['screeningAlertId'],
        'rule': value['rule'],
        'useExistingHits': value['useExistingHits'],
    };
}

